import CarLoan from './CarLoan';
import { NAME } from './constants';

export default {
  NAME,
  CarLoan,
};
